var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "publication-card" }, [
    _c("div", {
      staticClass: "publication-card-image",
      style: { backgroundImage: "url(" + _vm.info.image + ")" }
    }),
    _c("div", { staticClass: "publication-card-info" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n      " + _vm._s(_vm.info.title) + "\n    ")
      ]),
      _c("div", {
        staticClass: "description",
        domProps: { innerHTML: _vm._s(_vm.info.announcement) }
      }),
      _c("div", { staticClass: "date" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm._f("date")(_vm.info.publishedOn, { showYear: true })) +
            "\n    "
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }